import { EGender, IAccount } from '../../../account/types';
import { IApiAccount } from './account.types';

export const accountSerializer = (
  apiAccount: IApiAccount
): { account: IAccount } => {
  const attributes = apiAccount.attributes;

  const account = {
    id: apiAccount.id,
    attributes: {
      email: attributes.email,
      hasCompletedProfile: attributes.hasCompletedProfile,
      nickname: attributes.nickname,
      status: attributes.status,
      kvk: attributes.kvk,
      gender: attributes.kvk.charAt(0) as EGender,
      isCrossSell: attributes.is_crosssell,
      wantedGender: attributes.kvk.charAt(1) as EGender,
      privacy: attributes.setting,
    },
    pictures: [],
    optins: undefined,
  };

  return {
    account,
  };
};
